import { computed } from "vue";
import { useStore } from "vuex";

export function usePermissions() {
  const store = useStore();

  const permissions = computed(
    () => store.getters["tenantId/getPermissions"] || []
  );

  const userPermissionNames = computed(() => {
    const user = store.getters["tenantId/getUser"];
    return user?.permissions?.map((p) => p.name) || [];
  });

  function can(permission) {
    if (!permission) return true;
    return store.getters["tenantId/hasPermission"](permission);
  }

  const canManageUsers = computed(() =>
    userPermissionNames.value.includes("ManageUsers")
  );
  const canManageRoles = computed(() =>
    userPermissionNames.value.includes("ManageRoles")
  );

  return {
    permissions,
    can,
    canManageUsers,
    canManageRoles,
  };
}
